import porschePlaceholder from '../assets/images/porsche-placeholder-cut.png';
import mercedesPlaceholder from '../assets/images/mercedes-placeholder.png';
 
export const PLACEHOLDER_IMAGES: Record<string, string> = {
  porsche: porschePlaceholder,
  mercedes: mercedesPlaceholder,
};
 